import {
  PurchaseBudgetRequisitionStateTypes,
  PurchaseBudgetRequisitionActionTypes,
} from "./PurchaseBudgetRequisition.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: PurchaseBudgetRequisitionStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const PurchaseBudgetRequisitionReducer = (
  state: PurchaseBudgetRequisitionStateTypes = INITIAL_STATE,
  action: any
): PurchaseBudgetRequisitionStateTypes => {
  switch (action.type) {
    case PurchaseBudgetRequisitionActionTypes.FETCH_ALL_PURCHASE_BUDGET_REQUISITION:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case PurchaseBudgetRequisitionActionTypes.FETCH_ALL_PURCHASE_BUDGET_REQUISITION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case PurchaseBudgetRequisitionActionTypes.FETCH_ALL_PURCHASE_BUDGET_REQUISITION_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PurchaseBudgetRequisitionActionTypes.FETCH_ALL_PURCHASE_BUDGET_REQUISITION_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case PurchaseBudgetRequisitionActionTypes.FETCH_ONE_PURCHASE_BUDGET_REQUISITION:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case PurchaseBudgetRequisitionActionTypes.FETCH_ONE_PURCHASE_BUDGET_REQUISITION_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case PurchaseBudgetRequisitionActionTypes.FETCH_ONE_PURCHASE_BUDGET_REQUISITION_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case PurchaseBudgetRequisitionActionTypes.FETCH_ONE_PURCHASE_BUDGET_REQUISITION_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default PurchaseBudgetRequisitionReducer; 